export default "__VITE_ASSET__tE6MpViY__"